import React, { useState } from 'react';
import { FaBriefcase, FaGraduationCap, FaHandHoldingHeart, FaRocket, FaPlane, FaUserCheck } from 'react-icons/fa';
import '../styles/ForJobSeekers.css';
import Toast from '../components/Toast';

const benefits = [
  {
    icon: <FaBriefcase />,
    title: 'Exclusive Opportunities',
    description: 'Access job openings not advertised elsewhere through our extensive employer network.'
  },
  {
    icon: <FaGraduationCap />,
    title: 'Career Guidance',
    description: 'Receive personalized career advice and guidance from experienced recruiters.'
  },
  {
    icon: <FaHandHoldingHeart />,
    title: 'Dedicated Support',
    description: 'Your dedicated recruiter supports you throughout the entire job search journey.'
  },
  {
    icon: <FaRocket />,
    title: 'Fast-Track Process',
    description: 'Our streamlined process gets you in front of hiring managers quickly.'
  },
  {
    icon: <FaPlane />,
    title: 'Visa, Travel and Relocation',
    description: 'Comprehensive assistance with visa processing, travel coordination, and relocation support for international opportunities.'
  },
  {
    icon: <FaUserCheck />,
    title: 'Interview Prep',
    description: 'Preparation assistance to help you ace your interviews and land your dream job.'
  }
];

const jobCategories = [
  'Healthcare & Medical',
  'Information Technology',
  'Engineering',
  'Finance & Accounting',
  'Manufacturing',
  'Administrative',
  'Executive & Management',
  'Other'
];

const countries = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
  'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
  'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
  'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
  'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
  'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
  'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos',
  'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
  'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
  'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
  'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau',
  'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania',
  'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal',
  'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea',
  'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan',
  'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela',
  'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

const ForJobSeekers = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    category: '',
    experience: '',
    currentLocation: '',
    desiredSalary: '',
    availability: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [toast, setToast] = useState({ isVisible: false, message: '', type: 'success' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear error for this field when user starts typing
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };

  const handleFileChange = (e) => {
    if (errors.resume) {
      setErrors({
        ...errors,
        resume: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First name is required';
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Last name is required';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    }
    if (!formData.country) {
      newErrors.country = 'Country is required';
    }
    if (!formData.category) {
      newErrors.category = 'Job category is required';
    }
    if (!formData.experience) {
      newErrors.experience = 'Years of experience is required';
    }

    const resumeInput = document.getElementById('resume');
    if (!resumeInput || !resumeInput.files || resumeInput.files.length === 0) {
      newErrors.resume = 'Resume is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const submitData = new FormData();
      Object.keys(formData).forEach(key => {
        submitData.append(key, formData[key]);
      });

      const resumeInput = document.getElementById('resume');
      if (resumeInput && resumeInput.files && resumeInput.files[0]) {
        submitData.append('resume', resumeInput.files[0]);
      }

      const response = await fetch('/api/job-seeker', {
        method: 'POST',
        body: submitData,
      });

      const result = await response.json();

      if (result.success) {
        setToast({ isVisible: true, message: 'Thank you for submitting your information! Our team will review your profile and contact you with relevant opportunities.', type: 'success' });
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          country: '',
          category: '',
          experience: '',
          currentLocation: '',
          desiredSalary: '',
          availability: '',
          message: ''
        });
        // Reset file input
        if (resumeInput) {
          resumeInput.value = '';
        }
        setErrors({});
        setSubmitAttempted(false);
      } else {
        setToast({ isVisible: true, message: result.message || 'Failed to submit application. Please try again.', type: 'error' });
      }
    } catch (error) {
      console.error('Error submitting job seeker form:', error);
      setToast({ isVisible: true, message: 'Failed to submit application. Please try again later.', type: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="job-seekers-page">
      <Toast 
        message={toast.message} 
        type={toast.type} 
        isVisible={toast.isVisible} 
        onClose={() => setToast({ ...toast, isVisible: false })}
      />
      <section className="page-hero" style={{backgroundImage: 'url(/images/job-search-hero.jpg)'}}>
        <div className="container">
          <h1>For Job Seekers</h1>
          <p>Find your next career opportunity with JWCS</p>
        </div>
      </section>

      <section className="seeker-intro">
        <div className="container">
          <div className="intro-grid">
            <div className="intro-content">
              <h2>Your Career Partner</h2>
              <p>
                Whether you're looking for your first job, seeking a career change, or aiming for that
                executive position, JWCS is here to help. We work with top employers across multiple
                industries to bring you exclusive opportunities that match your skills, experience,
                and career aspirations.
              </p>
            </div>
            <div className="intro-image">
              <img
                src="https://images.pexels.com/photos/5439381/pexels-photo-5439381.jpeg?auto=compress&cs=tinysrgb&w=600"
                alt="Business professionals in meeting"
                className="intro-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="dream-future">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Your Dream Awaits</span>
            <h2 className="section-title">Transform Your Life</h2>
            <p className="section-description">Join thousands who have built better lives for themselves and their families</p>
          </div>
          <div className="dream-grid">
            <div className="dream-card dream-card-large">
              <img
                src="/images/happy-family.png"
                alt="Happy family celebrating new opportunities"
              />
              <div className="dream-overlay">
                <h3>A Better Life for Your Family</h3>
                <p>Secure opportunities that provide stability and prosperity</p>
              </div>
            </div>
            <div className="dream-card">
              <img
                src="/images/health-care.jpeg"
                alt="Nurse in professional healthcare setting"
              />
              <div className="dream-overlay">
                <h3>Healthcare Careers</h3>
                <p>Join world-class medical teams</p>
              </div>
            </div>
            <div className="dream-card">
              <img
                src="/images/skilled-trade-jobs.png"
                alt="Skilled worker at construction site"
              />
              <div className="dream-overlay">
                <h3>Skilled Trade Jobs</h3>
                <p>Build your future abroad</p>
              </div>
            </div>
            <div className="dream-card">
              <img
                src="/images/corporate-opportunities.png"
                alt="Professional in corporate setting"
              />
              <div className="dream-overlay">
                <h3>Corporate Opportunities</h3>
                <p>Advance your career globally</p>
              </div>
            </div>
            <div className="dream-card">
              <img
                src="/images/industrial-workers.png"
                alt="Industrial workers at work"
              />
              <div className="dream-overlay">
                <h3>Industrial Workers</h3>
                <p>Passionate workers</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="seeker-benefits">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Why Choose JWCS</span>
            <h2 className="section-title">Benefits for Job Seekers</h2>
          </div>

          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div className="benefit-card" key={index}>
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="resume-form-section">
        <div className="container">
          <div className="form-wrapper">
            <div className="form-header">
              <h2>Submit Your Resume</h2>
              <p>Take the first step towards your dream career</p>
            </div>

            <form className="seeker-form" onSubmit={handleSubmit} noValidate>
              <div className="form-row">
                <div className={`form-group ${errors.firstName ? 'has-error' : ''}`}>
                  <label htmlFor="firstName">First Name *</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                  {errors.firstName && <span className="error-message">{errors.firstName}</span>}
                </div>
                <div className={`form-group ${errors.lastName ? 'has-error' : ''}`}>
                  <label htmlFor="lastName">Last Name *</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                  {errors.lastName && <span className="error-message">{errors.lastName}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group ${errors.email ? 'has-error' : ''}`}>
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
                <div className={`form-group ${errors.phone ? 'has-error' : ''}`}>
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  {errors.phone && <span className="error-message">{errors.phone}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group ${errors.country ? 'has-error' : ''}`}>
                  <label htmlFor="country">Country *</label>
                  <select
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country, index) => (
                      <option key={index} value={country}>{country}</option>
                    ))}
                  </select>
                  {errors.country && <span className="error-message">{errors.country}</span>}
                </div>
                <div className={`form-group ${errors.category ? 'has-error' : ''}`}>
                  <label htmlFor="category">Job Category *</label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                  >
                    <option value="">Select Category</option>
                    {jobCategories.map((cat, index) => (
                      <option key={index} value={cat.toLowerCase()}>{cat}</option>
                    ))}
                  </select>
                  {errors.category && <span className="error-message">{errors.category}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group ${errors.experience ? 'has-error' : ''}`}>
                  <label htmlFor="experience">Years of Experience *</label>
                  <select
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                  >
                    <option value="">Select Experience</option>
                    <option value="entry">Entry Level (0-2 years)</option>
                    <option value="mid">Mid Level (3-5 years)</option>
                    <option value="senior">Senior (6-10 years)</option>
                    <option value="executive">Executive (10+ years)</option>
                  </select>
                  {errors.experience && <span className="error-message">{errors.experience}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="currentLocation">Current Location</label>
                  <input
                    type="text"
                    id="currentLocation"
                    name="currentLocation"
                    value={formData.currentLocation}
                    onChange={handleChange}
                    placeholder="City, State"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="availability">Availability</label>
                  <select
                    id="availability"
                    name="availability"
                    value={formData.availability}
                    onChange={handleChange}
                  >
                    <option value="">Select Availability</option>
                    <option value="immediate">Immediate</option>
                    <option value="2weeks">2 Weeks Notice</option>
                    <option value="1month">1 Month</option>
                    <option value="flexible">Flexible</option>
                  </select>
                </div>
              </div>

              <div className="form-group full-width">
                <label htmlFor="message">Tell Us About Yourself</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Share your career goals, key skills, and what type of opportunity you're looking for..."
                ></textarea>
              </div>

              <div className={`form-group full-width file-upload ${errors.resume ? 'has-error' : ''}`}>
                <label htmlFor="resume">Upload Resume (PDF, DOC, DOCX) *</label>
                <input
                  type="file"
                  id="resume"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                />
                <p className="file-hint">Maximum file size: 5MB</p>
                {errors.resume && <span className="error-message">{errors.resume}</span>}
              </div>

              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForJobSeekers;
